<template>
	<div class="ReCardTicketFaqNest mt-2">
		<card class="mt-3" v-if="!bIsEdit">
			<div class="">
				<div >
					<h5><i class="tim-icons icon-bulb-63 text-success mr-3"></i>Часто задаваемые вопросы</h5>
				</div>
				
				<div class="row mx-0 align-items-center mb-3">
					<div class="tStatus-select mr-3">
						<el-select
							class="col-md px-0 select-primary"
							v-model="topic_value" 
							clearable
							filterable
							placeholder="Выбрать тему заявки"
							size="large"
							@change="filterFAQ()"
						>
							<el-option
								class="select-primary"
								v-for="tg in masTopicTags"
								:key="tg.value"
								:label="tg.label"
								:value="tg.id"
							>
							</el-option>
						</el-select>
					</div>
					<!-- <base-button type="success" class="groupfloor" simple  @click="filterFAQ()">Применить</base-button> -->
						
				</div>
				<!-- <div v-if="this.objFAQ && this.objFAQ.length > 0" class="">
					<template v-for="faq in objFAQ">
						<ReCardTicketFaq :objFAQ="faq" />
					</template>
				</div> -->
				<div v-if="this.objFAQ && Object.keys(this.objFAQ).length > 0" class="row">
					<div v-for="(group, index) in objFAQ" :key="index" class="col-lg-6 col-md-12">
						<template v-for="tg in masTopicTags">
							<h6 v-if="tg.id == index" class="mb-2 mt-4">{{tg.label}}</h6>
						</template>
						<ReCardTicketFaq v-for="faq in group" :objFAQ="faq" :key="faq.id"/>
						<!-- <div class="d-flex justify-content-between">
							
							<div class="bntGroup">
								<base-button type="primary" class="groupfloor" simple @click="gotoFAQPage(faq.id)" >На страницу<i class="tim-icons icon-double-right mr-2"></i></base-button>
							</div>
						</div> -->
						<!-- <ReCardTicketFaq :objFAQ="faq" /> -->
					</div>
				</div>
			</div>
			<!-- <Pagination class="mt-3" :class="[{'': parseInt(masFAQ_total) > 0}, {'d-none': parseInt(masFAQ_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masFAQ_total)" 
				:perPage="parseInt(50)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination> -->

		</card>
		
		
	</div>
</template>

<script>
import { Select, Option, Button } from 'element-ui';
import ReCardTicketFaq from 'src/our_components/ReCardTicketFaq.vue';
// import Pagination from 'src/our_components/RePagination';

export default {
	name: "ReCardTicketFaqNest",
	components: {
		[Option.name]: Option,
        [Select.name]: Select,
        [Button.name]: Button,
		ReCardTicketFaq,
		// Pagination,
	},
	props: {
		bIsEdit:{
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			ver: 1,
			objFAQ: {},
			// objFAQ: [],
			masFAQ_total: 0,
			topic_value: '',
			masTopicTags: [],
			count2page: 50,
		};
	},
	computed: {},
	methods: {
		getFAQ(topic){
			let filter = {};
			filter = {"topicTag":topic};

			this.$GVO.ApiCall('TicketSystem.GET_TicketFAQ',{flt: {...filter, 'c2p':this.count2page, act: 1, grouped:true} })
			.then((objApi) => {
				if(objApi.success === true){
					// console.log('objApi.data',typeof objApi.data);
					if(Object.keys(objApi.data).length > 0){
						this.objFAQ = objApi.data;
						// console.log('this.objFAQ',this.objFAQ);
						if(objApi.total!=undefined) { this.masFAQ_total=objApi.total; }
					}
				}else{
					this.objFAQ = {};
					this.masFAQ_total=0;
				}
			}).catch(errorObjApi => {this.objFAQ = {}; this.masFAQ_total=0; console.error(errorObjApi);});
		},
		filterFAQ(){
			this.objFAQ=[];
			this.getFAQ(this.topic_value);
		},
		gotoFAQPage(id){
			location.href = '/data/ticketsystem/faq/id/'+id;
		}
		// pClick(e){
		// 	this.objGetParams['p'] = parseInt(e);
		// 	this.getFAQ();
		// },

	},
	mounted() {
		this.$GVO.LoadCatPromise('CAT_TICKET_TAGS')
		.then((objApi) => {
			if(objApi=== true){
				for (let i = 0; i < this.$GVO.cats.CAT_TICKET_TAGS.length; i++) {
					const element = this.$GVO.cats.CAT_TICKET_TAGS[i];
					if(element.act==1) this.masTopicTags.push({'value':element.val,'label':element.val, 'id':element.id}); //вопрос val или id ?
				}
			}
		})
		.catch(errorObjApi => {console.error(errorObjApi); });

		this.getFAQ();
	}
};
</script>

<style scoped>


</style>
